import axios from "axios";

const BASE = "/ncrm/workflows/contact-normalization";

export const scanContactNormalizationQueue = (payload = {}) =>
  axios.post(`${BASE}/scan`, payload);

export const fetchContactNormalizationQueue = (params = {}) =>
  axios.get(`${BASE}/queue`, { params });

export const fetchContactNormalizationQueueRecord = (id, workflowInstanceId) =>
  axios.get(`${BASE}/queue/${id}`, {
    params: { workflow_instance_id: workflowInstanceId },
  });

export const updateContactNormalizationQueueRecord = (id, payload = {}) =>
  axios.patch(`${BASE}/queue/${id}`, payload);

export const applyContactNormalizationRecord = (id, workflowInstanceId) =>
  axios.post(`${BASE}/queue/${id}/apply`, {
    workflow_instance_id: workflowInstanceId,
  });

export const applyContactNormalizationBatch = (workflowInstanceId, queueIds = [], options = {}) =>
  axios.post(`${BASE}/apply`, {
    workflow_instance_id: workflowInstanceId,
    queue_ids: queueIds,
    ...options,
  });
